import { render, staticRenderFns } from "./xtypeSectionHeader.vue?vue&type=template&id=63da3d4f&scoped=true&"
import script from "./xtypeSectionHeader.vue?vue&type=script&lang=js&"
export * from "./xtypeSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./xtypeSectionHeader.vue?vue&type=style&index=0&id=63da3d4f&scoped=true&lang=css&"
import style1 from "./xtypeSectionHeader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da3d4f",
  null
  
)

component.options.__file = "xtypeSectionHeader.vue"
export default component.exports